module.exports = __webpack_public_path__ + "img/arch-normal.cc7160ef.svg";